import styled from "styled-components";

const Input = styled.input`
  position: relative;
  padding-left: 10px;
  z-index: 1;
  width: 100%;
  border: 1px solid #919191;
  border-radius: 3px;
  outline: none;
  background-color: transparent;
  box-shadow: 0 1px 2px rgb(0 0 0 / 8%) inset;
  color: #333;
  transition: border-color 0.15s ease-out 0s;
  -webkit-appearance: none;
  line-height: 1.4;
`;
export default Input;
